import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'rsuite';

const BulkDeleteModal = ({ open, onClose, selectedCount, collectionName, onConfirm, loading }) => (
  <Modal open={open} onClose={onClose} size="xs">
    <Modal.Header>
      <Modal.Title>Bulk Delete Entries</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to remove <strong>{selectedCount}</strong> entries from{' '}
      <strong>{collectionName}</strong>? This action cannot be undone.
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose} appearance="subtle">
        Cancel
      </Button>
      <Button onClick={onConfirm} appearance="primary" color="red" loading={loading}>
        Delete {selectedCount} Entries
      </Button>
    </Modal.Footer>
  </Modal>
);

BulkDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
  collectionName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BulkDeleteModal.defaultProps = {
  loading: false,
};

export default BulkDeleteModal;
